export enum SupportedLanguageEnum {
  'PT-BR' = 'pt-BR',
  'EN-US' = 'en',
}
